import { WSPage } from "@wingspanhq/fe-component-library";
import React from "react";
import { Redirect, RouteComponentProps } from "react-router-dom";
import {
  getPathnameMyResourcesDetails,
  PARAMETER_MY_RESOURCES_PLAN_ENROLLMENT_ID,
  PATH_MY_RESOURCES
} from "../paths";
import { queriesInsuranceCoverages } from "../../../v3/query/queriesInsuranceCoverages";
import { WSQueries } from "../../../query/WSQuery";
import { useQueriesOn } from "../../../shared/hooks/useQueriesOn";

export const RouteMyRedirectFromEnrollmentToDetails: React.FC<
  RouteComponentProps<
    {
      [PARAMETER_MY_RESOURCES_PLAN_ENROLLMENT_ID]: string;
    },
    any,
    {
      backPath?: string;
    }
  >
> = props => {
  // v3 `listInsuranceCoverages` takes no sort; the redirect only cares whether
  // the enrollment resolved to exactly one coverage, so ordering is moot
  const qInsuranceCoverages =
    queriesInsuranceCoverages.listInsuranceCoverages.useQuery(
      {
        filter: {
          sourceId: { eq: props.match.params.planEnrollmentId }
        },
        page: {
          size: 2
        }
      },
      {
        retry: false
      }
    );

  useQueriesOn(
    "error",
    () => {
      props.history.push(PATH_MY_RESOURCES);
    },
    qInsuranceCoverages
  );

  return (
    <WSPage>
      <WSQueries queries={{ qInsuranceCoverages }}>
        {({ qInsuranceCoveragesData }) => {
          const insurances = qInsuranceCoveragesData.data ?? [];

          if (insurances.length === 1) {
            return (
              <Redirect
                to={getPathnameMyResourcesDetails("", insurances[0].id!)}
              />
            );
          }

          return <Redirect to={PATH_MY_RESOURCES} />;
        }}
      </WSQueries>
    </WSPage>
  );
};
